import { FC } from 'react'
import {
  Datagrid, DateField, FilterList, FilterListItem, FunctionField, List,
  TextField, useTranslate,
} from 'react-admin'
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew'
import VpnKeyIcon from '@mui/icons-material/VpnKey'
import { EnabledChip, FilterAside } from '../../components'
import { ApplicationOut } from '../../types/apiRequests'
import { getPerPage } from '../../utils/usePerPage'

import { AUTH_TYPE_KEYS } from './authTypeLabels'

const ApplicationFilters: FC = () => {
  const translate = useTranslate()
  return (
    <FilterAside>
      <FilterList label={translate('filters.status')} icon={<PowerSettingsNewIcon />}>
        <FilterListItem label="filters.active" value={{ enabled: true }} />
        <FilterListItem label="filters.inactive" value={{ enabled: false }} />
      </FilterList>

      <FilterList label={translate('filters.authType')} icon={<VpnKeyIcon />}>
        {/* eslint-disable camelcase */}
        <FilterListItem label="data.authTypeOauthClientCredentials" value={{ auth_type: 'oauth_client_credentials' }} />
        <FilterListItem label="data.authTypeClientCertificate" value={{ auth_type: 'client_certificate' }} />
        <FilterListItem label="data.authTypeCustomHeaders" value={{ auth_type: 'custom_headers' }} />
        {/* eslint-enable camelcase */}
      </FilterList>
    </FilterAside>
  )
}

const ApplicationList: FC = () => {
  const translate = useTranslate()
  return (
    <List sort={{ field: 'display_name', order: 'ASC' }} exporter={false} perPage={getPerPage()} aside={<ApplicationFilters />}>
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="display_name" label="data.displayName" />
        <FunctionField<ApplicationOut>
          label="data.authType"
          render={(record) => translate(AUTH_TYPE_KEYS[record.auth_type] || record.auth_type)}
        />
        <FunctionField<ApplicationOut> label="data.enabled" render={() => <EnabledChip />} />
        <DateField source="created" showTime label="data.createdAt" />
      </Datagrid>
    </List>
  )
}

export default ApplicationList
